'use strict';
define(['./util', './analytics', './constantvalues', './../data/config/app', './carouseltemplate'], function (Utils, analytics, Constantvalues, Config, Carouseltemplate) {
    var retryTime = 100;
    var MAX_RETRIES = 30;
    var retries = 0;

    function recentlyviewedcomponent() {
        this.getwindowData = setInterval(this.checkwindowData.bind(this), retryTime);
    }

    recentlyviewedcomponent.prototype = {
        checkwindowData: function () {
            var _this = this;
            if (window.targetRecommendations || retries > MAX_RETRIES) {
                clearInterval(_this.getwindowData);
                if (!window.targetRecommendations) {
                    return;
                }
                if (window.targetRecommendations.recent && (window.recentlyviewedEnabled === 'true')) {
                    document.querySelector('.navfooter-recentlyviewed').style.display = 'block';
                    _this.generaterecentlyviewedtemplate(window.targetRecommendations.recent);
                }
            } else {
                retries++;
            }
        },
        generaterecentlyviewedtemplate: function (recentlyviewedItem) {
            this.el = recentlyviewedItem.recommendedProducts;
            new Carouseltemplate(this.el).init();
        }
    };
    return recentlyviewedcomponent;
});


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/recentlyviewedcomponent.js
 **/